import { useEffect, useState } from "react";
import { Icon as Iconify } from '@iconify/react';
import { lionIcons } from "../components/helpersIcons";
import { InfoToolTip } from "./generalComponents";

export const ContrastCheckerWCAG = (props) => {
    const colors = { text: {
            bad: "text-red-500",
            mediocre: "text-amber-500",
            success: "text-green-500",
        }, background: {
            bad: "bg-red-100",
            mediocre: "bg-amber-100",
            success: "bg-green-100",
        }
    }

    const [contrast, setContrast] = useState(0)
    //props:
    //color1 and color2 as input
    useEffect(() => {
        if (props.color1 && props.color2) {
            setContrast(getContrastRatio(props.color1, props.color2))
        }
        else setContrast(0)
    }, [props.color1, props.color2])

    function hexToRgb(hex) {
    hex = hex.replace('#', '');

    // Support shorthand hex (#abc)
    if (hex.length === 3) {
        hex = hex.split('').map(c => c + c).join('');
    }

    const r = parseInt(hex.substring(0, 2), 16) / 255;
    const g = parseInt(hex.substring(2, 4), 16) / 255;
    const b = parseInt(hex.substring(4, 6), 16) / 255;

    return [r, g, b];
    }

    function getLuminance(hex) {
    const [r, g, b] = hexToRgb(hex).map(c => {
        return c <= 0.03928
        ? c / 12.92
        : Math.pow((c + 0.055) / 1.055, 2.4);
    });

    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
    }

    function getContrastRatio(color1, color2) {
    const lum1 = getLuminance(color1);
    const lum2 = getLuminance(color2);

    const brightest = Math.max(lum1, lum2);
    const darkest = Math.min(lum1, lum2);

    return (brightest + 0.05) / (darkest + 0.05);
    }

    function isContrastTooLow(textColor, backgroundColor, minRatio = 4.5) {
    const ratio = getContrastRatio(textColor, backgroundColor);

    return {
        tooLow: ratio < minRatio,
        ratio: ratio.toFixed(2)
    };
    }
    const getMessageColor = (forText) => {
        if (forText) {
            if (contrast < 3.1) return colors.text.bad
            else if (contrast < 4.5) return colors.text.mediocre
            return colors.text.success
        }
        else {
            if (contrast < 3.1) return colors.background.bad
            else if (contrast < 4.5) return colors.background.mediocre
            return colors.background.success
        }
    }
    const getWarningKeyword = () => {
        if (contrast < 3.1) return 'Bad'
        else if (contrast < 4.5) return 'Attention'
        return 'Ok'

    }

    return <div>
        {contrast > 0 && <div className="flex flex-row gap-x-1 items-end">
            <div className="font-semibold">
                <div className="text-sm">WCAG color contrast</div>
                <div className={`${getMessageColor()} ${getMessageColor(true)} px-2 py-1 rounded text-lg font-poppins text-center`}>{contrast.toFixed(2)}</div>
            </div>
            <div className="mb-1">
                <InfoToolTip
                    custom={<div className={`${getMessageColor(true)} flex flex-row items-center gap-x-1`}>
                                <div className="text-sm font-semibold">{getWarningKeyword()}</div>
                                <Iconify icon="material-symbols:info-outline" width={22} />
                            </div>}
                    placement='right'
                    headLine='Color Contrast Ratio'
                    message={<div className="font-poppins">
                                <div className="text-lg font-bold mt-2">Goal</div>
                                <div>Text can be seen by more people.</div>
                                <div className="text-lg font-bold mt-2">What to do</div>
                                <div>Provide sufficient contrast between text and its background.</div>
                                <div className="text-lg font-bold mt-2">Why it's important</div>
                                <div>Some people cannot read faint text.</div>
                                <div className={`${colors.text.success} mt-4 text-lg font-bold`}>4.5 or more</div>
                                <div>Good</div>
                                <div className={`${colors.text.mediocre} mt-4 text-lg font-bold`}>Between 3.1 and 4.5</div>
                                <div>Fine for large texts, not enough for small texts</div>
                                <div className={`${colors.text.bad} mt-4 text-lg font-bold`}>Below 3.1</div>
                                <div>Not good enough</div>
                            </div>}
                />
             </div>
            </div>}
    </div>
}